import React from 'react';

/**
 * Generic admin top-bar.
 * Supply whatever children you need – search box, title, buttons, etc.
 */
export default function TopBar({ children }) {
  return (
    <nav
      className="navbar bg-white border-bottom px-4"
      style={{ minHeight: '54px' }}   /* same height everywhere */
    >
      {children}
    </nav>
  );
}